// extracted by mini-css-extract-plugin
export default {"css":"Css_css__Pu07K","divs":"Css_divs__uK0zp"};